import Form from 'app/components/Form';

import {
  createAccountBilling,
  updateAccountBilling
} from 'app/services/billings';

import {
  getAccounts
} from 'app/services/accounts';

import {
  getBillings
} from 'app/services/billings';

import {
  formatOptions
} from 'app/utils/options';

const AccountBillingForm = props => {
  const {
    accountBilling,
    onClose,
    onSubmit,
    action
  } = props;

  let header = null;

  const getAccountOptions = async (page = 1, perPage = 100, filter = null, recordId = null) => {
    let params = {
      page,
      per_page: perPage,
      record_id: recordId,
    }

    if (filter) {
      params.filter_model = {
      name: [{
        filterClass: 'text',
        filterType: 'contains',
        value: filter
      }]
      }
    }

    let resp = await getAccounts(params);
    return formatOptions(resp.records);
  }

  const getBillingOptions = async (page = 1, perPage = 100, filter = null, recordId = null) => {
    let params = {
      page,
      per_page: perPage,
      record_id: recordId,
    }

    if (filter) {
      params.filter_model = {
      name: [{
        filterClass: 'text',
        filterType: 'contains',
        value: filter
      }]
      }
    }

    let resp = await getBillings(params);
    return formatOptions(resp.records);
  }

  let fields = [
    { name: 'billing_id', label: 'Billing', type: 'autocomplete', value: accountBilling?.billing_id, valueType: 'integer', getOptions: getBillingOptions },
    { name: 'account_id', label: 'Account', type: 'autocomplete', value: accountBilling?.account_id, valueType: 'integer', getOptions: getAccountOptions },
    { name: 'billing_name', label: 'Customer ID', type: 'text', value: accountBilling?.billing_name },
  ]

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      onSubmit
    }} />
  );
}

export default AccountBillingForm;
